<template>
    <div>
        <b-row>
            <b-col>
                <table>
                    <tr>
                        <td>
                            巾<b-form-input style="margin-bottom: 0;" class="input_size" v-model="width_size" placeholder="巾"></b-form-input>cm x<br>
                        </td>
                        <td>
                            丈<b-form-input style="margin-bottom: 0;" class="input_size" v-model="height_size" placeholder="丈"></b-form-input>cm<br>
                        </td>
                    </tr>
                    <tr v-if="
                    $store.state.step3_data.hida !=='' &&
                    $store.state.step3_data.open !=='' &&
                    $store.state.step3_data.size_min_max[hida] &&
                    $store.state.step3_data.size_min_max[hida][$store.state.step3_data.open] &&
                    (price_file.indexOf('SWH') > -1 || price_file.indexOf('SWS') > -1 ||  price_file.indexOf('SWHL') > -1) &&
                    style_selected2_name === ''
                    ">
                        <td v-if="$store.state.step3_data.open === '両開き'" style="font-size: 0.8rem;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span v-if="hida==='2倍ヒダ'">51～約600cm</span>
                            <span v-if="hida==='1.5倍ヒダ'">67～約800cm</span>
                            <span v-if="hida==='フラット'">41～1200cm</span>
                        </td>
                        <td v-else-if="$store.state.step3_data.open === '片開き'" style="font-size: 0.8rem;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span v-if="hida==='2倍ヒダ'">26～約600cm</span>
                            <span v-if="hida==='1.5倍ヒダ'">34～約800cm</span>
                            <span v-if="hida==='フラット'">21～約600cm</span>
                        </td>
                        <td style="font-size: 0.8rem;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;60～400cm</td>
                    </tr>
                    <tr v-else-if="
                        $store.state.step3_data.hida !=='' && $store.state.step3_data.open !==''
                    ">
                        <td style="font-size: 0.8rem;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{width_min}}～{{width_max}}cm</td>
                        <td style="font-size: 0.8rem;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{height_min}}～{{height_max}}cm</td>
                    </tr>
                </table>
            </b-col>
            <b-col style="padding-top: 0.4rem;">
                <span v-if="select_option">
                    <span class="custom-title">代表サイズ</span>
                    <b-form-select v-model="select_size" :options="select_option"/>
                </span>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'input_size',
        data() {
            return {
            }
        },
        created : function() {
        },
        watch: {
            width_size : function(v) {
                this.width_size = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) })
            },
            height_size : function(v) {
                this.height_size = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) })
            },
            select_size: function(val, old) {
                if(this.isset(val)){
                    let split_data = val.split('×');
                    this.width_size  = split_data[0].replace('cm','')
                    this.height_size = split_data[1].replace('cm','')
                    this.$store.commit('updateOptionSelected', {name:'width_size', value:this.width_size})
                    this.$store.commit('updateOptionSelected', {name:'height_size', value:this.height_size})
                }
            },
        },
        computed: {
            width_min : {
                get :function() {
                    if(this.$store.state.step2_data.style_selected2_name==='プレーン小窓'){
                        return 18
                    }
                    let hida = this.get_hida()
                    let add_hida = this.get_add_hida()
                    let open = this.$store.state.step3_data.open
                    //開閉不可対策
                    if(open === '開閉不可'){
                        open='片開き';
                    }
                    let width_min = ''
                    let id_size = ''
                    let add_width_min = ''
                    if(
                        this.$store.state.step3_data.size_min_max[hida] &&
                        this.$store.state.step3_data.size_min_max[hida][open] &&
                        typeof(this.$store.state.step3_data.size_min_max[hida][open].width_min) !== 'undefined'
                    ){
                        width_min = this.$store.state.step3_data.size_min_max[hida][open].width_min
                    }
                    if(
                        this.$store.state.step3_data.id_size[hida] &&
                        this.$store.state.step3_data.id_size[hida][open] &&
                        this.$store.state.step3_data.id_size[hida][open]['wid'] &&
                        this.$store.state.step3_data.id_size[hida][open]['wid'][1]
                    ){
                        if(
                            (
                                this.$store.state.step2_data.style_selected2_name === 'スカラップフリル センターウェーブ' ||
                                this.$store.state.step2_data.style_selected2_name === 'スカラップトリム センターウェーブ'
                            ) && this.$store.state.xlsx_data.item_data['FT' + this.$store.state.price_data.price_item_number]['ヨコ使い'] !== '○'
                        ){
                            id_size = this.$store.state.step3_data.id_size[hida][open]['wid'][3]['ws']
                        }else{
                            id_size = this.$store.state.step3_data.id_size[hida][open]['wid'][1]['ws']
                        }

                    }
                    if(
                        this.$store.state.step3_data.add_size_min_max &&
                        this.$store.state.step3_data.add_size_min_max[add_hida] &&
                        this.$store.state.step3_data.add_size_min_max[add_hida][open]
                    ){
                        add_width_min = this.$store.state.step3_data.add_size_min_max[add_hida][open].width_min
                    }
                    //console.log('width_min = ' + width_min + ' id_size = ' + id_size)
                    if(add_width_min !=='' && add_width_min > 0){
                        id_size = add_width_min
                    }
                    if(id_size !=='' && width_min<id_size){
                        width_min = id_size
                        //width_min = id_size + '加'
                    }
                    return width_min
                }
            },
            width_max : {
                get :function() {
                    if(this.$store.state.step2_data.style_selected2_name==='プレーン小窓'){
                        return 65
                    }
                    let hida = this.get_hida()
                    let add_hida = this.get_add_hida()
                    let open = this.$store.state.step3_data.open
                    //開閉不可対策
                    if(open === '開閉不可'){
                        open='片開き';
                    }
                    let width_max = ''
                    let id_size = ''
                    let add_width_max = ''
                    if(
                        this.$store.state.step3_data.size_min_max[hida] &&
                        this.$store.state.step3_data.size_min_max[hida][open] &&
                        typeof(this.$store.state.step3_data.size_min_max[hida][open].width_max) !== 'undefined'
                    ){
                        width_max =  this.$store.state.step3_data.size_min_max[hida][open].width_max
                    }
                    if(
                        this.$store.state.step3_data.id_size[hida] &&
                        this.$store.state.step3_data.id_size[hida][open] &&
                        this.$store.state.step3_data.id_size[hida][open]['wid']
                    ){
                        if(
                            this.$store.state.step3_data.add_size_min_max &&
                            this.$store.state.step3_data.add_size_min_max[add_hida] &&
                            this.$store.state.step3_data.add_size_min_max[add_hida][open]
                        ){
                            add_width_max = this.$store.state.step3_data.add_size_min_max[add_hida][open].width_max
                            if(this.$store.state.step3_data.add_size_min_max[add_hida]){
                                let index = this.$store.state.step3_data.add_size_min_max[add_hida][open].wid
                                if(index && this.$store.state.step3_data.id_size[hida][open]['wid'][index]){
                                    if(
                                        ( this.$store.state.step2_data.style_selected2_name === 'スカラップフリル センターウェーブ' ||
                                          this.$store.state.step2_data.style_selected2_name === 'スカラップトリム センターウェーブ') &&
                                        this.$store.state.xlsx_data.item_data['FT' + this.$store.state.price_data.price_item_number]['ヨコ使い'] !== '○'
                                    ){
                                        id_size = this.$store.state.step3_data.id_size[hida][open]['wid'][5]['we']
                                    }else{
                                        id_size = this.$store.state.step3_data.id_size[hida][open]['wid'][index]['we']
                                    }
                                }
                            }

                        }
                        //console.log('width_max = ' + width_max + ' add_width_max=' + add_width_max + ' id_size = ' + id_size)
                        if(add_width_max !=='' && add_width_max > 0){
                            id_size = add_width_max
                        }
                        if(id_size !=='' && width_max>id_size){
                            width_max = id_size
                            //width_max = id_size + '加'
                        }
                    }
                    return width_max
                }
            },
            height_min : {
                get :function() {
                    let hida = this.get_hida()
                    let add_hida = this.get_add_hida()
                    let open = this.$store.state.step3_data.open
                    //開閉不可対策
                    if(open === '開閉不可'){
                        open='片開き';
                    }
                    let height_min = ''
                    let id_size = ''
                    let add_hight_min = ''
                    if(
                        this.$store.state.step3_data.size_min_max[hida] &&
                        this.$store.state.step3_data.size_min_max[hida][open] &&
                        typeof(this.$store.state.step3_data.size_min_max[hida][open].height_min) !== 'undefined'
                    ){
                        height_min = this.$store.state.step3_data.size_min_max[hida][open].height_min
                    }
                    if(
                        this.$store.state.step3_data.id_size[hida] &&
                        this.$store.state.step3_data.id_size[hida][open] &&
                        this.$store.state.step3_data.id_size[hida][open]['hid'] &&
                        this.$store.state.step3_data.id_size[hida][open]['hid'][1]
                    ){
                        id_size = this.$store.state.step3_data.id_size[hida][open]['hid'][1]['hs']
                    }
                    if(
                        this.$store.state.step3_data.add_size_min_max &&
                        this.$store.state.step3_data.add_size_min_max[add_hida] &&
                        this.$store.state.step3_data.add_size_min_max[add_hida][open]
                    ){
                        add_hight_min = this.$store.state.step3_data.add_size_min_max[add_hida][open].height_min
                    }
                    //console.log('height_min = ' + height_min + ' id_size = ' + id_size+ ' add_hight_min='+add_hight_min)
                    if(add_hight_min !=='' && add_hight_min> 0){
                        id_size = add_hight_min
                    }
                    if(id_size !=='' && height_min<id_size){
                        height_min = id_size
                        //height_min = id_size + '加'
                    }
                    return height_min
                }
            },
            height_max : {
                get :function() {
                    let hida = this.get_hida()
                    let add_hida = this.get_add_hida()
                    let open = this.$store.state.step3_data.open
                    //開閉不可対策
                    if(open === '開閉不可'){
                        open='片開き';
                    }
                    let height_max = ''
                    let id_size = ''
                    let add_hight_max = ''
                    if(
                        this.$store.state.step3_data.size_min_max[hida] &&
                        this.$store.state.step3_data.size_min_max[hida][open] &&
                        typeof(this.$store.state.step3_data.size_min_max[hida][open].height_max) !== 'undefined'
                    ){
                        height_max =  this.$store.state.step3_data.size_min_max[hida][open].height_max
                    }
                    if(
                        this.$store.state.step3_data.id_size[hida] &&
                        this.$store.state.step3_data.id_size[hida][open] &&
                        this.$store.state.step3_data.id_size[hida][open]['hid']
                    ){
                        if(
                            this.$store.state.step3_data.add_size_min_max &&
                            this.$store.state.step3_data.add_size_min_max[add_hida] &&
                            this.$store.state.step3_data.add_size_min_max[add_hida][open]
                        ){
                            add_hight_max = this.$store.state.step3_data.add_size_min_max[add_hida][open].height_max
                            if(this.$store.state.step3_data.add_size_min_max[add_hida]){
                                let index = this.$store.state.step3_data.add_size_min_max[add_hida][open].hid
                                if(index && this.$store.state.step3_data.id_size[hida][open]['hid'][index]){
                                    id_size = this.$store.state.step3_data.id_size[hida][open]['hid'][index]['he']
                                }
                            }

                        }
                        //console.log('height_max = ' + height_max + ' add_hight_max=' + add_hight_max + ' id_size = ' + id_size)
                        if(add_hight_max !== '' && add_hight_max > 0){
                            id_size = add_hight_max
                        }
                        if(id_size !== '' && height_max>id_size){
                            height_max = id_size
                            //height_max = id_size + '加'
                        }
                    }
                    return height_max
                }
            },
            hida : {
              get :function(){
                  return this.get_hida()
              }
            },
            add_hida : {
                get :function(){
                    return this.get_add_hida()
                }
            },
            select_option: {
                get : function(){
                    if(
                        (this.$store.state.step2_data.style_selected1_id === '' && this.$store.state.step2_data.style_selected2_id === '') ||
                        (typeof(this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id]) === 'undefined' &&
                            typeof(this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id]) === 'undefined') ||
                        (typeof(this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id]) === 'undefined' &&
                            typeof(this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id]) === 'undefined') ||
                        typeof(this.$store.state.xlsx_select_data.select_data['代表サイズ']) === 'undefined'
                    ){
                        return false
                    }
                    if(this.$store.state.step2_data.style_selected2_id !== '' &&
                        typeof(this.$store.state.xlsx_select_data.select_data['代表サイズ'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]) !=='undefined'
                    ) {
                        return this.$store.state.xlsx_select_data.select_data['代表サイズ'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['代表サイズ'].option
                    }
                    else if(this.$store.state.step2_data.style_selected1_id !== '' &&
                        typeof(this.$store.state.xlsx_select_data.select_data['代表サイズ'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]) !=='undefined'
                    ) {
                        return this.$store.state.xlsx_select_data.select_data['代表サイズ'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['代表サイズ'].option
                    }
                    return ''
                }
            },
            width_size: {
                get: function () {
                    return this.$store.state.step3_data.width_size
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'width_size', value:value})
                }
            },
            height_size: {
                get: function () {
                    return this.$store.state.step3_data.height_size
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'height_size', value:value})
                }
            },
            select_size: {
                get: function () {
                    return this.$store.state.step3_data.select_size
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'select_size', value:value})
                }
            },
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }

                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            item_data: {
                get: function () {
                    if(
                        this.$store.state.step1_data.item_number &&
                        this.$store.state.xlsx_data.item_data &&
                        typeof(this.$store.state.xlsx_data.item_data['FT'+this.$store.state.step1_data.item_number]) !=='undefined'
                    ){
                        return this.$store.state.xlsx_data.item_data['FT'+this.$store.state.step1_data.item_number]
                    }
                    return ''
                },
            },
            price_file: {
                get: function(){
                    return this.$store.state.price_data.price_file
                }
            }
        },
        methods:{
            /**
             *  値の有無をチェック
             *  phpのisset()に相当
             */
            isset : function(data){
                if(data === "" || data === null || data === undefined){
                    return false;
                }else{
                    return true;
                }
            },
            get_hida : function(){
                let hida = this.$store.state.step3_data.hida
                if(hida==='' || hida === undefined){
                    return ''
                }
                hida = hida.split('/')[0]
                hida = hida.replace(/約/g,'')
                if(hida==='1倍'){
                    hida = 'フラット'
                }
                else if(hida==='2.3倍'){
                    hida = '2倍ヒダ'
                }
                else{
                    hida = hida+'ヒダ'
                }
                return hida
            },
            get_add_hida : function(){
                let hida = ''
                const style_selected1_name = this.$store.state.step2_data.style_selected1_name
                const style_selected2_name = this.$store.state.step2_data.style_selected2_name
                const search_data = this.$store.state.search_data
                let group1_1 = ''
                if(this.$store.state.step2_data.style_selected1_id !== ''){
                    group1_1 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                }
                let group2 = ''
                let group2_1 = ''
                if(this.$store.state.step2_data.style_selected2_id !== ''){
                    group2 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    group2_1 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                }
                let yokotsukai = ''
                if(this.$store.state.xlsx_data.item_data && this.$store.state.price_data.price_item_number){
                    yokotsukai = this.$store.state.xlsx_data.item_data['FT' + this.$store.state.price_data.price_item_number]['ヨコ使い']
                }

                if(
                    style_selected2_name === 'ボーダースタイル サイド' ||
                    style_selected2_name === 'フリンジスタイルI型'
                ){

                }
                else if(

                    style_selected2_name === '裏地付きボーダースタイル サイド' ||
                    style_selected2_name==='ループトップスタイル' ||
                    style_selected2_name==='フリルスタイル L型' ||
                    style_selected2_name==='フリルスタイル Z型' ||
                    style_selected2_name==='トリムスタイル Z型' ||
                    style_selected2_name==='ダブルトリムスタイル' ||
                    group2==='フリンジスタイル' ||
                    (group2 === '吊元チェンジ' && yokotsukai !== '○') ||
                    (group2 === 'フリルスタイル' && yokotsukai !== '○') ||
                    (group2 === 'トリムスタイル' && yokotsukai !== '○') ||
                    (group2 === 'スカラップスタイル' && yokotsukai !== '○')
                ){
                    hida = 'フラット'
                }
                else if(
                    style_selected2_name ==='ボーダースタイル ボトム' ||
                    group2 === '吊元チェンジ' ||
                    group2 === 'フリルスタイル' ||
                    group2 === 'トリムスタイル' ||
                    group2 === 'スカラップスタイル'
                ){
                    hida = this.$store.state.step3_data.hida
                    if(hida==='' || hida === undefined){
                        return ''
                    }
                    hida = hida.split('/')[0]
                    hida = hida.replace(/約/g,'')
                    if(hida==='1倍'){
                        hida = 'フラット'
                    }
                    else if(hida==='2.3倍'){
                        hida = '2倍ヒダ'
                    }
                    else{
                        hida = hida+'ヒダ'
                    }
                }
                return hida
            }
        }
    }

</script>

<style scoped>
    .custom-select{
        width: auto;
    }
</style>